<template>
<div>
  <vs-col type="flex" vs-justify="center" vs-align="center">
      <vs-card class="cardx">
        <div slot="header">
          <h3>
            Estado General BoxStreamer
          </h3>
        </div>
        <div>
          <States/>
        </div>
    </vs-card>
  </vs-col>
</div>
</template>

<script>
import States from './components/box/States.vue';

export default {
	name: 'StarterPage',
  components: {
    States,
  },
}
</script>
